import React, { useState } from 'react';
interface ToggleProps {
  label?: string;
  description?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  danger?: boolean;
}
export function Toggle({
  label,
  description,
  checked = false,
  onChange,
  disabled,
  danger
}: ToggleProps) {
  const [isChecked, setIsChecked] = useState(checked);
  const handleChange = () => {
    if (disabled) return;
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };
  return <div className="flex items-start gap-3" data-id="element-657">
      <button type="button" role="switch" aria-checked={isChecked} disabled={disabled} onClick={handleChange} className={`
          relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent
          transition-colors duration-200 ease-in-out
          focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-slate-900
          disabled:opacity-50 disabled:cursor-not-allowed
          ${isChecked ? danger ? 'bg-red-600 focus:ring-red-500' : 'bg-blue-600 focus:ring-blue-500' : 'bg-slate-200 dark:bg-slate-700 focus:ring-slate-500'}
        `} data-id="element-658">
        <span className={`
            pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0
            transition duration-200 ease-in-out
            ${isChecked ? 'translate-x-4' : 'translate-x-0'}
          `} data-id="element-659" />
      </button>
      {(label || description) && <div className="flex-1" data-id="element-660">
          {label && <span className={`text-sm font-medium ${danger && isChecked ? 'text-red-700 dark:text-red-400' : 'text-slate-900 dark:text-slate-100'}`} data-id="element-661">
              {label}
            </span>}
          {description && <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-662">
              {description}
            </p>}
        </div>}
    </div>;
}